import React from "react";
import { Grid2, type SxProps, type Theme } from "@mui/material";
import type { BookingScheduleInterface } from "../../features/Booking-Form/typings/booking.types";
import { ScheduleEventCheckinButton } from "./schedule-event-checkin-button.component";
import { ScheduleEventUnlockButton } from "./ScheduleCalendar/schedule-event-unlock-button.component";

type P = {
  schedule: BookingScheduleInterface;
  allSchedules?: BookingScheduleInterface[];
  refetchAllSchedule?: () => void;
  onClickUnlock?: () => void;
  isEditable: boolean;
  isColleagueScheduleEditable: boolean;
  containerSx?: SxProps<Theme>;
  buttonSx?: SxProps<Theme>;
  layout?: "grid" | "inline";
};

export const ScheduleCheckInUnlockActions: React.FC<P> = ({
  schedule,
  allSchedules,
  refetchAllSchedule,
  onClickUnlock,
  isEditable,
  isColleagueScheduleEditable,
  containerSx,
  buttonSx,
  layout = "grid"
}) => {
  if (!(isEditable || isColleagueScheduleEditable)) {
    return null;
  }

  const actions = (
    <>
      <ScheduleEventCheckinButton
        selectedSchedule={schedule}
        allSchedules={allSchedules}
        refetchAllSchedule={refetchAllSchedule}
        buttonSx={buttonSx}
      />
      <ScheduleEventUnlockButton
        doorLockData={schedule.doorLockData}
        onClickUnlock={onClickUnlock}
      />
    </>
  );

  if (layout === "inline") {
    return (
      <Grid2
        container
        columnGap={1}
        sx={{
          flexShrink: 0,
          alignItems: "center",
          "& .MuiButton-root": {
            width: "auto"
          },
          ...(containerSx as object)
        }}
        data-testid="unlock-and-checkin-btn-grid"
      >
        {actions}
      </Grid2>
    );
  }

  return (
    <Grid2
      data-testid="unlock-and-checkin-btn-grid"
      container
      size={{ xs: 12 }}
      sx={{ mb: 2, columnGap: 2, ...containerSx }}
    >
      {actions}
    </Grid2>
  );
};
